<template>
	<div>
		<ha-form-wizard ref="wizard" :key="scene.name" :scene="scene" type="advanced" :edit="edit"
			:loading="loading"></ha-form-wizard>
		<div class="d-flex flex justify-space-around mt-8">
			<v-btn width="40%" min-width="100px" outlined text @click="reset">Cancel</v-btn>
			<v-btn width="40%" min-width="100px" outlined color="ocean" @click="submit">Save</v-btn>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		scene: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			loading: false,
			edit: true,
		};
	},
	methods: {
		validate() {
			return this.$refs.wizard.validate();
		},
		reset() {
			this.$refs.wizard.reset();
		},
		async submit() {
			if (this.loading) return;
			this.loading = true;
			try {
				await this.$refs.wizard.saveScene();
				await this.$store.dispatch("k4/controller/refreshModel");
				this.$store.commit("k4/scenes/setSelectedSceneName", this.scene.name);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
